import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { createPasswordForUser , setApplicationNumber } from '../../../actions/loginActions';
import { useDispatch, useSelector } from 'react-redux';
import CustomButton from '../../../components/CustomButton';
import CustomTextField from '../../../components/CustomTextField';
// Images
import ApplicationIcon from '../../../assets/application.svg';
import UserIcon from '../../../assets/user.svg';
import PhoneIcon from '../../../assets/phone.svg';
import EmailIcon from '../../../assets/email.svg';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import PopUpModal from '../../../components/PopUpModal';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%',
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '80%',
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '30%',
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '25%',
    },
  },
}));

const GeneratePassword = () => {
  const defaultInputs = {
    email: {
      type: 'email',
      value: '',
      errorLabel: '',
      error: false,
    },
    userName: {
      type: 'generic',
      value: '',
      errorLabel: '',
      error: false,
    },
    mobileNo: {
      type: 'phone',
      value: '',
      errorLabel: '',
      error: false,
    },
    uid: {
      type: 'form',
      value: '',
      errorLabel: '',
      error: false,
    },
    CountryCode: {
      type: 'generic',
      value: '+91',
    },
  };
  const classes = useStyles();
  const childRef = useRef();
  /* States */
  const [inputs, setInputs] = useState(defaultInputs);
  const [isDisabled, setDisabled] = useState(true);

  // Redux Props
  const dispatch = useDispatch();

  const message = useSelector((state) =>
    get(state, 'loginReducer.isGenerateSwipe.message', '')
  );
  const isError = useSelector((state) =>
    get(state, 'loginReducer.isGenerateSwipe.error', '')
  );
  const isLoginLoading = useSelector((state) =>
    get(state, 'loadingReducer.isLoginLoading', false)
  );
  const appNumber = useSelector(state => get(state, 'loginReducer.applicationNumber', ''));

  const onChangeTextInput = (id, value) => {
    setInputs((prevInput) => ({
      ...prevInput,
      [id]: { ...prevInput[id], value: value },
    }));
    if (id == 'uid') {
      dispatch(
        setApplicationNumber({
          uid: value
        })
      )
    }
  };
  const handleDisable = () => {
    let isEmail = validateEmail('email', inputs.email.value);
    if (
      (inputs.uid.value || appNumber.uid) &&
      inputs.userName.value.length > 3 &&
      inputs.mobileNo.value &&
      isEmail
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };
  useEffect(() => {
    handleDisable();
  }, [
    inputs.email.value,
    inputs.userName.value,
    inputs.mobileNo.value,
    inputs.uid.value,
    appNumber.uid
  ]);

  const onCreatePass = () => {
    let isUId = validateForm('uid', inputs.uid.value);
    let isUID2 = validateForm('uid', appNumber.uid);
    let isMobileNo = handleLengthValidation('mobileNo', inputs.mobileNo.value.trim());
    let isEmail = validateEmail('email', inputs.email.value);
    let isUser = validateGeneric('userName', inputs.userName.value.trim());
    if ((isUId || isUID2) && isMobileNo && isEmail && isUser) {
      createPasswordForUser(
        inputs.uid.value?inputs.uid.value:appNumber.uid,
        inputs.mobileNo.value.trim(),
        inputs.userName.value.trim(),
        inputs.email.value,
        dispatch
      ).then(() => {
        childRef.current.handleClickOpen();
      });
    }
  };

  const header = isError ? (
    <div>Opps! Error in generating password </div>
  ) : (
      <div>Hurray! Password generated sucessfully</div>
    );
  const body = isError ? (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {message}
    </Alert>
  ) : (
      <React.Fragment>
        <Alert severity="success">
          <AlertTitle>Success</AlertTitle>
        Generating password successful,You&apos;ll recieve the password on your
        mobile
      </Alert>
        <div className="seprator" />
        <p className="flex flex-center">
          <Link to="/login" className="secondary-link">
            Back to Login
        </Link>
        </p>
      </React.Fragment>
    );

  const handleLengthValidation = (id, val) => {
    let expression = /^([0]|\+91|91)$/.test(inputs.CountryCode.value);
    if (!inputs.mobileNo.value || !val) {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
        },
      }));
      return false;
    } else if (!expression) {
      if (
        inputs.mobileNo.value.trim().length <= 10 &&
        inputs.mobileNo.value.trim().length >= 6
      ) {
        setInputs((prevInput) => ({
          ...prevInput,
          [id]: {
            ...prevInput[id],
            errorLabel: '',
          },
        }));
        return true;
      } else {
        setInputs((prevInput) => ({
          ...prevInput,
          [id]: {
            ...prevInput[id],
            errorLabel: 'Please enter valid Mobile Number (6-10 digits )',
            error: true,
          },
        }));
        return false;
      }
    } else {
      if (inputs.mobileNo.value.trim().length === 10) {
        setInputs((prevInput) => ({
          ...prevInput,
          [id]: {
            ...prevInput[id],
            errorLabel: '',
            error: false,
          },
        }));
        return true;
      } else {
        setInputs((prevInput) => ({
          ...prevInput,
          [id]: {
            ...prevInput[id],
            errorLabel: 'Please enter valid Mobile Number (10 digits)',
            error: true,
          },
        }));
        return false;
      }
    }
  };

  const validateGeneric = (id, val) => {
    if (!inputs.userName.value || !val) {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
        },
      }));
      return false;
    } else {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
        },
      }));
      return true;
    }
  };

  const validateEmail = (id, val) => {
    var reg = /^([A-Za-z0-9_\-.])+@+([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
    if (!inputs.email.value || !val) {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
        },
      }));
      return false;
    } else if (!reg.test(inputs.email.value)) {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: 'Please enter valid email',
          error: true,
        },
      }));
      return false;
    } else {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
          error: false,
        },
      }));
      return true;
    }
  };
  const validateForm = (id, val) => {
    if (!(inputs.uid.value||appNumber.uid) || !val) {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
        },
      }));
      return false;
    } else if (!/^\d{8}$/.test(inputs.uid.value?inputs.uid.value:appNumber.uid)) {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: 'Please enter valid Application Form Number',
          error: true,
        },
      }));
      return false;
    } else {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
          error: false,
        },
      }));
      return true;
    }
  };

  const handleKeypress = (e) => {
    //it triggers by pressing the enter key
    let code = e.keyCode || e.which;
    if (code === 13) {
      onCreatePass();
    }
  };

  const handleDisabled = () => {
    let isUId = validateForm('uid', inputs.uid.value);
    let isUID2 = validateForm('uid', appNumber.uid);
    let isMobileNo = handleLengthValidation('mobileNo', inputs.mobileNo.value.trim());
    let isEmail = validateEmail('email', inputs.email.value);
    let isUser = validateGeneric('userName', inputs.userName.value);
    if ((isUId || isUID2) && isMobileNo && isEmail && isUser) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  useEffect(() => {
    handleDisabled();
  }, [
    inputs.email.value,
    inputs.userName.value,
    inputs.mobileNo.value,
    inputs.uid.value,
    appNumber.uid
  ]);

  return (
    <div className="form-wrapper">
      <div className="greeting">
        <h1 className="welcome">Generate Password</h1>
        <p className="info">Fill your registration details</p>
      </div>

      <form noValidate autoComplete="off">
        <div className="input-container">
          <CustomTextField
            color="secondary"
            fullWidth
            id="uid"
            label="Application Number"
            error={inputs.uid.error}
            helperText={inputs.uid.errorLabel}
            onChange={(e) => onChangeTextInput('uid', e.target.value)}
            icon={ApplicationIcon}
            defaultValue={appNumber.uid}
          />
        </div>
        <div className="flex-row width-100-per">
          <div className="input-container width-40-per">
            <CustomTextField
              color="secondary"
              fullWidth
              id="CountryCode"
              label="Country Code"
              type="mobile"
              value={inputs.CountryCode.value}
              onChange={(e) => onChangeTextInput('CountryCode', e.target.value)}
              onKeyPress={handleKeypress}
            />
          </div>
          <div className="input-container width-55-per ml-extra">
            <CustomTextField
              color="secondary"
              fullWidth
              id="mobileNo"
              label="Mobile"
              type="mobile"
              onChange={(e) => onChangeTextInput('mobileNo', e.target.value)}
              helperText={inputs.mobileNo.errorLabel}
              error={inputs.mobileNo.error}
              icon={PhoneIcon}
              onKeyPress={(handleLengthValidation, handleKeypress)}
            />
          </div>
        </div>
        <div className="input-container">
          <CustomTextField
            color="secondary"
            fullWidth
            id="userName"
            label="Fullname"
            type="name"
            onChange={(e) => onChangeTextInput('userName', e.target.value)}
            helperText={inputs.userName.errorLabel}
            error={inputs.userName.error}
            icon={UserIcon}
            onKeyPress={handleKeypress}
          />
        </div>
        <div className="input-container">
          <CustomTextField
            color="secondary"
            fullWidth
            id="email"
            label="Email"
            type="email"
            onChange={(e) => onChangeTextInput('email', e.target.value)}
            helperText={inputs.email.errorLabel}
            error={inputs.email.error}
            icon={EmailIcon}
            onKeyPress={handleKeypress}
          />
        </div>
        <div className="mb-10">
          <CustomButton
            name="Generate Password"
            handler={() => onCreatePass()}
            disabled={isDisabled || isLoginLoading}
            progressShow={isLoginLoading}
            className={isLoginLoading ? 'loading-btn' : ''}
          />
        </div>
      </form>
      <div className="seprator">
        <span>or</span>
      </div>

      <p className="flex flex-center">
        <Link to="/login" className="secondary-link">
        Back to Login
        </Link>
      </p>
      <PopUpModal
        ref={childRef}
        header={header}
        body={body}
        width={classes.dialogCustomizedWidth}
      />
    </div>
  );
};
GeneratePassword.propTypes = {
  location: PropTypes.object,
};

export default GeneratePassword;
